export default __webpack_public_path__ + "static/media/timi_bg2.998fd6c0.png";